/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Customers_Without_Order_ContactInputs */

const en_queue_customers_without_order_contact = /** @type {(inputs: Queue_Customers_Without_Order_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Customers without a contact for the orders`)
};

/**
* | output |
* | --- |
* | "Customers without a contact for the orders" |
*
* @param {Queue_Customers_Without_Order_ContactInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_customers_without_order_contact = /** @type {((inputs?: Queue_Customers_Without_Order_ContactInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Customers_Without_Order_ContactInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_customers_without_order_contact(inputs)
});